import { call, put, takeEvery, fork, all } from 'redux-saga/effects';
import axios from 'axios';


function * listCreateAsync(data){
  try{
     const api = yield call([axios, axios.post], '/api/lists', data.payload)
     yield put({type:'REQUEST_LIST_CREATE_SUCCESS', val:api.data});
     yield put({type:'REQUEST_LIST_CREATE_C_SUCCESS', val:api.data});
     yield put({type:'REQUEST_FOLDER_ITEM_UPDATE_SUCCESS', val:{folder_type:'LISTS', new_folder_id:api.data.folder_id}})
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * listUpdateAsync(data){
  try{
    console.log('list update', data);
     const api = yield call([axios, axios.put], '/api/lists/'+data.id, data.payload)
     yield put({type:'REQUEST_LIST_UPDATE_SUCCESS', val:api.data});
     yield put({type:'REQUEST_LIST_UPDATE_C_SUCCESS', val:api.data});
     yield put({type:'REQUEST_FOLDER_ITEM_UPDATE_SUCCESS', val:{folder_type:'LISTS', old_folder_id:api.data.old_folder_id, new_folder_id:api.data.folder_id}})
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * listGetAsync(data){
  try{
     const api = yield call([axios, axios.get], '/api/lists/'+data.id);
     yield put({type:'REQUEST_LIST_GET_SUCCESS', val:api.data});
     yield put({type:'REQUEST_LIST_GET_C_SUCCESS', val:api.data});
   }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}


function * listIndexAsync(){
  try{
     const api = yield call([axios, axios.get], '/api/lists')
     yield put({type:'REQUEST_LIST_INDEX_SUCCESS', val:api.data});
     yield put({type:'REQUEST_FOLDER_INDEX_SUCCESS', val:{folders:api.data.folders, items:api.data.lists, folder_type:'LISTS'}});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * listMergeAsync(data){
  try{
     const api = yield call([axios, axios.post], '/api/lists/merge', data.payload)
     window.location.href='/';
     yield put({type:'REQUEST_LIST_MERGE_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * listDeleteAsync(data){
  try{
     const api = yield call([axios, axios.post], '/api/lists/delete', data.payload)
     if(data.payload.mode=='queue_mode'){
       yield put({type:'REQUEST_QUEUE_DELETE_SUCCESS', val:api.data});
     }else{
       yield put({type:'REQUEST_LIST_DELETE_SUCCESS', val:api.data});
     }
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}


function * queueCreateAsync(data){
  try{
     const api = yield call([axios, axios.post], '/api/queues', data.payload)
     yield put({type:'REQUEST_QUEUE_CREATE_SUCCESS', val:api.data});
     yield put({type:'REQUEST_QUEUE_CREATE_C_SUCCESS', val:api.data});
     //yield put({type:'REQUEST_FOLDER_ITEM_UPDATE_SUCCESS', val:{folder_type:'QUEUES', old_folder_id:api.data.old_folder_id, new_folder_id:api.data.folder_id}})
 }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * queueUpdateAsync(data){
  try{
     const api = yield call([axios, axios.put], '/api/queues/'+data.id, data.payload)
     yield put({type:'REQUEST_QUEUE_UPDATE_SUCCESS', val:api.data});
     yield put({type:'REQUEST_QUEUE_UPDATE_C_SUCCESS', val:api.data});
     //yield put({type:'REQUEST_FOLDER_ITEM_UPDATE_SUCCESS', val:{folder_type:'QUEUES', old_folder_id:api.data.old_folder_id, new_folder_id:api.data.folder_id}})
   }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * queueGetAsync(data){
  try{
    const api = yield call([axios, axios.get], '/api/queues/'+data.id);
    yield put({type:'REQUEST_QUEUE_GET_SUCCESS', val:api.data});
    yield put({type:'REQUEST_QUEUE_GET_C_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}


function * queueIndexAsync(){
  try{
     const api = yield call([axios, axios.get], '/api/queues')
     yield put({type:'REQUEST_QUEUE_INDEX_SUCCESS', val:{queues:api.data.queues, folder_type:'QUEUES'}});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * queueMergeAsync(data){
  try{
     const api = yield call([axios, axios.post], '/api/queues/merge', data.payload)
     yield put({type:'REQUEST_QUEUE_MERGE_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * queueDeleteAsync(data){
  try{
     const api = yield call([axios, axios.post], '/api/queues/delete', data.payload)
     yield put({type:'REQUEST_QUEUE_DELETE_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}





function* Index_list(){yield takeEvery('REQUEST_LIST_INDEX', listIndexAsync);}
function* Get_list(){yield takeEvery('REQUEST_LIST_GET', listGetAsync);}
function* Create_list(){yield takeEvery('REQUEST_LIST_CREATE', listCreateAsync);}
function* Update_list(){yield takeEvery('REQUEST_LIST_UPDATE', listUpdateAsync);}
function* Merge_list(){yield takeEvery('REQUEST_LIST_MERGE', listMergeAsync);}
function* Delete_list(){yield takeEvery('REQUEST_LIST_DELETE', listDeleteAsync);}

function* Index_queue(){yield takeEvery('REQUEST_QUEUE_INDEX', queueIndexAsync);}
function* Get_queue(){yield takeEvery('REQUEST_QUEUE_GET', queueGetAsync);}
function* Create_queue(){yield takeEvery('REQUEST_QUEUE_CREATE', queueCreateAsync);}
function* Update_queue(){yield takeEvery('REQUEST_QUEUE_UPDATE', queueUpdateAsync);}
function* Merge_queue(){yield takeEvery('REQUEST_QUEUE_MERGE', queueMergeAsync);}
function* Delete_queue(){yield takeEvery('REQUEST_QUEUE_DELETE', queueDeleteAsync);}

export default function* Root_lists(){
  yield all([
    fork(Index_list),
    fork(Get_list),
    fork(Create_list),
    fork(Update_list),
    fork(Merge_list),
    fork(Delete_list),

    fork(Index_queue),
    fork(Get_queue),
    fork(Create_queue),
    fork(Update_queue),
    fork(Merge_queue),
    fork(Delete_queue)
  ])}
